
import React, { useState } from 'react';
import './style.scss'
import PropTypes from 'prop-types';

import cx from 'classnames';
import {
   MediaCardTitle,
   MediaContentButtonOptions,
   MediaCardWrapper,
   MediaImageCard,
} from 'common/designer-modules/modules/media/modules'
import StoryCard from 'common/designer-modules/modules/media/story';

import Link from 'common/components/modules/link';
import VideoMediaContent from 'common/designer-modules/modules/media/video';
import PhotosetMediaContent from 'common/designer-modules/modules/media/photoset';
import StoreMediaContent from 'common/designer-modules/modules/media/store';

const MediaCard = ({
   media = {},
   type,
   isLoading,
   cardSize,
   isAgeVerificationRequired,
   contentCardSettings,
   href,
   isNextApp,
   authUser,
   primaryColor,
   onShare,
   onClickLike,
   onClickLock,
   onClickTip,
   onAddFavorite,
   toggleWatchStatus,
}) => {
   const [likeFetching, setLikeFetching] = useState(false);
   const [favoritFetching, setFavoritFetching] = useState(false);

   return (
      <div
         className={ cx(
            {
               'relative flex flex-col h-auto gap-1 mms-media-card': true,
               'mms-media-small-card-size': cardSize === 's',
               'mms-media-medium-card-size': cardSize === 'm',
               'mms-media-large-card-size': cardSize === 'l',
            }
         ) }
      >
         <Link href={ href } isNextApp={ isNextApp } prefetch className='flex flex-col gap-1'>
            <MediaCardWrapper
               media={ media }
               type={ type }
               isLoading={ isLoading }
               contentCardSettings={ contentCardSettings }
               toggleWatchStatus={ Boolean(toggleWatchStatus) ? callback => {
                  toggleWatchStatus(type, media, callback, media.content_mapping_id)
               } : null }
            >

               {
                  'story' === type && (
                     <StoryCard
                        isAgeVerificationRequired={ isAgeVerificationRequired }
                        story={ media || {} }
                        primaryColor={ primaryColor }
                     />
                  )
               }
               {
                  ['video', 'recorded_stream'].includes(type) && (
                     <VideoMediaContent
                        isAgeVerificationRequired={ isAgeVerificationRequired }
                        data={ media || {} }
                        primaryColor={ primaryColor }

                     />
                  )
               }
               {
                  'photoset' === type && (
                     <PhotosetMediaContent
                        isAgeVerificationRequired={ isAgeVerificationRequired }
                        data={ media || {} }
                        primaryColor={ primaryColor }
                     />
                  )
               }

               {
                  'store' === type && (
                     <StoreMediaContent
                        isAgeVerificationRequired={ isAgeVerificationRequired }
                        data={ media || {} }
                        primaryColor={ primaryColor }
                     />
                  )
               }
               {
                  ['vault_video', 'vault_image'].includes(type) && (
                     <>
                        <MediaImageCard
                           poster={ media?.vault_bundle_item_poster_full_src   }
                           // lockedForSFW={ posterIsSfw }
                        />
                        {/* {
            posterIsSfw && (
               <AgeVerificationFrame
                  className='cover_image_wrapper_hover_element hidden z-10'
                  onClickVerifyAgeButton={ _ => {} }
               />
            )
         } */}
                     </>
                  )
               }


               {
                  !['vault_video', 'vault_image'].includes(type) && (
                     <MediaContentButtonOptions
                        data={ media }
                        isAuthUser={ Boolean(authUser) }
                        contentCardSettings={ contentCardSettings }
                        onClickLike={ Boolean(onClickLike) ?  _ => {
                           setLikeFetching(true)
                           onClickLike(type, media, () => {
                              setLikeFetching(false)
                           }, media.content_mapping_id)
                        } : null }
                        onClickLock={ _ => onClickLock(type, media) }
                        onClickTip={ _ => onClickTip(type, media) }
                        onChangeFavoriteItem={ Boolean(onAddFavorite) ? _ => {
                           setFavoritFetching(true)
                           onAddFavorite({ resource_type: type, resource_id: media.id }, () => {
                              setFavoritFetching(false)
                           }, media.content_mapping_id)
                        } : null }
                        onShare={ _ => onShare(type, media) }
                        likeFetching={ likeFetching }
                        favoritFetching={ favoritFetching }
                        type={ type }
                     />

                  )
               }

            </MediaCardWrapper>
            <MediaCardTitle
               media={ media }
               isAgeVerificationRequired={ isAgeVerificationRequired }
               isLoading={ isLoading }
               contentCardSettings={ contentCardSettings }
               type={ type }
            />
         </Link>
      </div>
   );
}

MediaCard.propTypes = {
   media: PropTypes.object,
   contentCardSettings: PropTypes.object,
   isAgeVerificationRequired: PropTypes.bool,
   isLoading: PropTypes.bool,
   type: PropTypes.string, //'video', 'photoset'
   cardSize: PropTypes.string,
   isNextApp: PropTypes.bool,
   href: PropTypes.string,
   primaryColor: PropTypes.string,
   authUser: PropTypes.object,
   onShare: PropTypes.func,
   onClickLike: PropTypes.func,
   onClickLock: PropTypes.func,
   onClickTip: PropTypes.func,
   onAddFavorite: PropTypes.func,
   toggleWatchStatus: PropTypes.func,
};

export default MediaCard;


